module.exports = __webpack_public_path__ + "static/img/PC-5.2f42627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/PC-5.png
// module id = tTDp
// module chunks = 0